module.exports = __webpack_public_path__ + "static/img/bg_image2.7afe0d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare/bg_image2.jpg
// module id = +WOU
// module chunks = 0